import React from 'react';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import css from './SubscriptionDeliveryDetails.css';

const SubscriptionDeliveryDetails = ({ subscription, intl }) => {
  const deliveryType = subscription?.attributes?.deliveryType;
  const deliveryToHome = subscription?.attributes?.deliveryToHome;
  const deliveryToProvider = subscription?.deliveryToProvider;

  const isHomeDelivery = deliveryType === 'home';
  const isStorePickup = deliveryType === 'store' || deliveryType === 'pickup';

  if (!isHomeDelivery && !isStorePickup) {
    return null;
  }

  const providerAttributes = deliveryToProvider?.attributes;
  const storeName = providerAttributes?.name || providerAttributes?.businessLocation?.search;

  return (
    <div className={css.deliveryContainer}>
      <div className={css.deliveryHeader}>
        <span className={css.badge}>
          {isHomeDelivery ? (
            <FormattedMessage id="SubscriptionDeliveryDetails.typeHome" defaultValue="Dostawa do domu (Kurier FEDEX)" />
          ) : (
            <FormattedMessage id="SubscriptionDeliveryDetails.typeStore" defaultValue="Odbiór w sklepie stacjonarnym" />
          )}
        </span>
      </div>

      {isHomeDelivery && deliveryToHome && (
        <div className={css.addressInfo}>
          <p className={css.label}>
            <FormattedMessage id="SubscriptionDeliveryDetails.deliveryAddressLabel" defaultValue="Adres dostawy:" />
          </p>
          <p className={css.addressText}>
            {deliveryToHome.address}
            {deliveryToHome.address2 && `, ${deliveryToHome.address2}`}
          </p>
          <p className={css.addressText}>{deliveryToHome.city}</p>
        </div>
      )}

      {isStorePickup && (
        <div className={css.addressInfo}>
          <p className={css.label}>
            <FormattedMessage id="SubscriptionDeliveryDetails.storeLocationLabel" defaultValue="Wybrany punkt odbioru:" />
          </p>
          <p className={css.storeName}>{storeName || '-'}</p>
          {providerAttributes?.businessLocation?.selectedPlace?.address && (
            <p className={css.addressText}>
              {providerAttributes.businessLocation.selectedPlace.address}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default injectIntl(SubscriptionDeliveryDetails);